import { Grid } from "@material-ui/core";
import React from "react";

const DataCell = ({ label, value, ...restProps }) =>
  value ? (
    <Grid item {...restProps}>
      {label && <div className="qd-data-cell-label">{label}</div>}
      <div>{value}</div>
    </Grid>
  ) : null;

export default DataCell;
